
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import actions from './actions'
import mutations from './mutations'

const state={
	msgCount: sessionStorage.getItem('msgCount'),		//扫码带来的销方id
	userName: sessionStorage.getItem('userName') || ''
}

const getters={}

const store = new Vuex.Store({
	state,
	getters,
	mutations,
	actions
})


export default store


// WEBPACK FOOTER //
// ./src/_vuex/store.js